import React, { Component } from 'react'
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Fade,
  Container
} from 'reactstrap'

import './style.scss'
import logo from '../../images/NavBar/logo.jpg'
import iconMenu from '../../images/NavBar/icon-menu.svg'
import iconMenuFechar from '../../images/NavBar/fechar.svg'
import '../../styles/animate.min.css'

export default class NavBar extends Component {
  constructor (props) {
    super(props)
    // console.log(iconMenu)
    this.toggleNavbar = this.toggleNavbar.bind(this)
    this._onClickLogo = this._onClickLogo.bind(this)
    this.state = {
      collapsed: true
    }
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }

  _onClickLogo () {
    !this.state.collapsed && this.setState({ collapsed: true })
  }

  render () {
    // const { location, title } = this.props
    return (
      <div style={{ marginBottom: '65.72px' }}>
        <Navbar color="faded" light fixed="top" className="bg-white ">
          <Container>
            <div className='row'>
              <div className='m-0 col-lg-11 col-10'>
                <a onClick={this._onClickLogo} href="/" >
                  <img
                    src={logo}
                    alt="Savasa Logo"
                    className="py-2"
                    id="logo-nav"
                    width="250"
                    style={{ border: 'none' }}
                  />
                </a>
              </div>
              <div
                onClick={this.toggleNavbar}
                className="col-lg-1 col-2 d-flex justify-content-end align-items-center toggle"
                style={{ border: 'none' }}
              >
                <img
                  src={this.state.collapsed ? iconMenu : iconMenuFechar}
                  width="40"
                  height="40"
                />
              </div>
            </div>
          </Container>
        </Navbar>
        <Container>
          <Fade
            in={!this.state.collapsed}
            unmountOnExit
            style={{
              margin: '0px 315px',
              float: 'right'
            }}
          >
            <Nav
              navbar
              style={{
                width: '300px',
                position: 'fixed',
                zIndex: '1029',
                overflow: 'hidden',
                marginTop: '-21px',
                backgroundColor: '#506477f7'
              }}
              className="text-right animated slideInDown"
            >
              <div className="p-5 mx-auto" id="nav-itens">
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/">HOME</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/sobre">A SAVASA</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/produtos">PRODUTOS</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/mercado">MERCADO</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/inovacao-qualidade-servico">
                    INOVAÇÃO, QUALIDADE E SERVIÇO
                  </NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/portfolio">PORTFOLIO</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/orcamento">ORÇAMENTO</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/trabalhe-conosco">TRABALHE CONOSCO</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="/contato">CONTATO</NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="tel:+551147936560">
                    <i className="fa fa-phone mr-2" aria-hidden="true" />
                    +55 11 4793.6560
                  </NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink href="https://api.whatsapp.com/send?phone=5511982593207">
                    <i className="fa fa-whatsapp mx-2" aria-hidden="true" />
                    WhatsApp
                  </NavLink>
                </NavItem>
                <NavItem onClick={this.toggleNavbar}>
                  <NavLink
                    href="mailto:comercial@savasa.com.br"
                    className="px-3"
                  >
                    {' '}
                    comercial@savasa.com.br{' '}
                  </NavLink>
                </NavItem>
              </div>
            </Nav>
          </Fade>
        </Container>
      </div>
    )
  }
}
